import { type RouteRecordRaw } from "vue-router";

/** Login público vive en Site/routes (PublicLayout). */
export const publicRoutes: RouteRecordRaw[] = [];

export const protectedRoutes: RouteRecordRaw[] = [
  {
    path: "profile",
    name: "profile",
    component: () => import("./pages/UserDetail.vue"),
    meta: { title: "menu.profile" },
  },
  {
    path: "users",
    name: "users",
    component: () => import("./pages/UserList.vue"),
    meta: { requiresAdmin: true, title: "users.title" },
  },
  {
    path: "users/create",
    name: "users-create",
    component: () => import("./pages/UserForm.vue"),
    meta: { requiresAdmin: true, title: "users.create" },
  },
  {
    path: "users/:id",
    name: "users-detail",
    component: () => import("./pages/UserDetail.vue"),
    meta: { title: "users.detail" },
  },
  {
    path: "users/:id/edit",
    name: "users-edit",
    component: () => import("./pages/UserForm.vue"),
    meta: { title: "users.edit" },
  },
];
